export default __webpack_public_path__ + "static/media/user.cd0a37e0.svg";